<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a class="nav-link m-tabs__link" data-toggle="tab" href="#customer_history" role="tab">
            <h5><span class="far fa-history"></span> Histórico de Logs de Envio de E-mail</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          class="tab-pane"
          :class="{
            active: true,
          }"
          id="customer_history"
          role="tabpanel"
        >
          <OmieSendEmailLogHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OmieSendEmailLogHistory from '@/components/invoices/omie/OmieSendEmailLogHistory';

export default {
  name: 'OmieSendEmailLogModal',
  components: {
    OmieSendEmailLogHistory,
  },
  methods: {
    closeThis() {
      this.$store.state.showOmieEmailSendLogs = null;
    },
  },
  computed: {},
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
